import request from "./axios";

function index(params) {
  return request({
    method: "get",
    url: `/deal/confirmation_dashboards`,
    params: params
  });
}

function stats(params) {
  return request({
    method: "get",
    url: `/deal/confirmation_dashboards/stats`,
    params: params
  });
}

const ConfirmationDashboardService = {
  index,
  stats
};

export default ConfirmationDashboardService;
